import React, { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useLocation } from "react-router-dom";
import { IconMessage } from "@tabler/icons-react";

import Header from "./Header";
import Sidebar from "./Sidebar";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const auth = useAuth();
  const location = useLocation();

  return (
    <div className="h-screen flex flex-col">
      {/* Mobile Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isMobile={true}
      />

      {/* Desktop Sidebar */}
      <Sidebar isOpen={true} onClose={() => {}} isMobile={false} />

      {/* Main Content Area */}
      <div className="lg:pl-64 h-full flex flex-col">
        {/* Sticky Header */}
        <Header onToggleSidebar={() => setSidebarOpen(true)} />

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto bg-gray-50">
          <div className="p-4 sm:p-6 lg:p-8 max-w-5xl mx-auto">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
